// extracted by mini-css-extract-plugin
export default {"notification-item":"notification-item__GmnMt","title":"title__2a9Hd","target":"target__1b7YT","date":"date__u-IvO","content":"content__1loM3","mark-as-read":"mark-as-read__3-1sK"};